import { IUser } from '@fff-web/fff-utilities';
import { UserMetadataType } from '../../services/types';
import { getHomepageHost } from '../../utils/getEnv';
import { flattenMetaDataOrdersAndTracking, formatCredits } from '../../utils/metaData';

/**
 * Gets the clean user context for the chatbot
 */
export const flattenUserInfo = (user: IUser): Record<string, string | number | boolean> => ({
  userId: user.userId ?? '',
  firstName: user.firstName,
  lastName: user.lastName,
  phoneNumber: user.phoneNumber ?? '',
  role: user.role,
  shippingCountry: user.shippingCountry,
  shippingState: user.shippingState,
  shippingZipCode: user.shippingZipCode,
  shippingCity: user.shippingCity,
  subscriptionEndDate: user.subscriptionEndDate,
  subscriptionStartDate: user.subscriptionStartDate,
  subscriptionState: user.subscriptionState,
  subscriptionType: user.subscriptionType,
  email: user.email,
  planCode: user.planCode,
  uuid: user.uuid ?? '',
});

/**
 * Processes the user metadata and returns the flattened orders and tracking
 */
export const flattenUserMetadata = (metaData: UserMetadataType) => {
  if (!metaData) return {};

  const flatOrdersAndTracking = flattenMetaDataOrdersAndTracking(metaData);

  return {
    phoneNumber: metaData.userAddressInfo.phoneNumber,
    addressLine1: metaData.userAddressInfo.addressLine1,
    seasonsActive: metaData.seasonsActive,
    nextBillDate: metaData.nextBillDate,
    creditCardOutdated: metaData.creditCardOutdated,
    creditsInfo: formatCredits(metaData.creditsInfo),
    ...flatOrdersAndTracking,
  };
};

/**
 * Gets the current path for the chat
 * TODO: This is a temporary solution, we should use a more dynamic approach once we finish the migration
 */
const getCurrentPathForChat = (): string => {
  let currentPath = window.location && window.location.pathname ? window.location.pathname : '';

  if (currentPath !== '/') {
    if (currentPath.endsWith('/')) {
      currentPath = currentPath.substr(0, currentPath.length - 1);
    }
  }

  if (currentPath.length === 0 && window.location.host === getHomepageHost()) {
    currentPath = '/homepage';
  }

  return currentPath;
};

/**
 * Checks if the current path is allowed to load the chat
 * TODO: This is a temporary solution, we should use a more dynamic approach once we finish the migration
 */
export const allowedChatPaths = [
  '/cancel-subscription',
  '/reactivate-my-membership',
  '/upgrade-confirmation',
  '/homepage',
  '/my-subscriptions',
  '/customize',
  '/my-account',
  '/my-account/orders',
  '/my-account/rate-and-review',
  '/shop',
  '/invite-friends',
  '/',
];

export const isChatPathAllowed = (): boolean => {
  const path = getCurrentPathForChat();
  const isSupport = window.location.host.includes('support');
  const isTracking = window.location.pathname.includes('track-shipment');
  const isLogin = window.location.pathname.includes('login');

  return (allowedChatPaths.includes(path) || isSupport || isTracking) && !isLogin;
};
